import React, {useState} from 'react';
import { ASSETS_WITH_COUNT, HIDE_ASSET } from './queries';
import { useMutation } from '@apollo/client';
import { MainContainer, ContentContainer, Input } from '../../elements';
import SubNav from './SubNav';
import DataTable from '@preflighttech/preflight-tables';
import { View, Text } from 'react-native';
import { Link } from 'app/src/utils/routing';
import Filter from 'app/src/elements/Filter';
import moment from 'moment';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';

const Assets = props => {
  const { withNav } = props;

  const [refetch, setRefetch] = useState();
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };
  const [hideAsset] = useMutation(
    HIDE_ASSET, { onCompleted: refetch }
  )

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  let currentYear = moment().format('YYYY');
  let years = [];
  for(let x = 0; x < 100; x++) {
    years.push(currentYear - x);
  }

  const columns = [
    {
      key: 'vin',
      label: 'VIN',
      sort: 'asc',
      content: (entry) => {
        return (
          <View>
            <Link to={`/sellers/${entry.entry.seller.id}/assets/${entry.entry.id}`}>
              {entry.entry.vin}
            </Link>
          </View>
        )
      }
    },
    {
      key: 'year',
      label: 'Year',
    },
    {
      key: 'make',
      label: 'Make',
    },
    {
      key: 'model',
      label: 'Model',
    },
    {
      key: 'uccExpiresOn',
      label: 'Eligible Sale Date',
      content: entry => {
        if(entry.entry.uccExpiresOn) {
          return moment(entry.entry.uccExpiresOn).format('M/D/YYYY')
        }
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: (entry) => {
        return (
          <View style={{display: 'inline-flex'}}>
            <Link
              to={`/sellers/${entry.entry.seller?.id}/assets/${entry.entry.id}`}
              style={{marginLeft: '10px'}}
            >
              View/Edit
            </Link>
          </View>
        )
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        <View style={{padding: '20px'}}>

          <Text>Vin:</Text>
          <input
            type={'text'}
            name="vin"
            onChange={e => setFilter('vin', e.target.value)}
            value={filters.vin || ''}
          />
          <Text>Year:</Text>
          <select
            type={'select'}
            name="year"
            onChange={e => setFilter('year', e.target.value)}
            value={filters.year || ''}
          >
            <option key={`year-any`}>{'Any'}</option>
            {years.map(year => <option key={`year-${year}`}>{year}</option>)}
          </select>
          <Text>Make:</Text>
          <input
            type={'text'}
            name="make"
            onChange={e => setFilter('make', e.target.value)}
            value={filters.make || ''}
          />
          <Text>Model:</Text>
          <input
            type={'text'}
            name="model"
            onChange={e => setFilter('model', e.target.value)}
            value={filters.model || ''}
          />
        </View>
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      {withNav &&
        <SubNav refetch={refetch} />
      }
      <ContentContainer>
        <Text><b>All Assets</b></Text>
        <DataTable.Gql
          setRefetch={setRefetch}
          query={ASSETS_WITH_COUNT}
          queryName='assetsWithCount'
          queryVariables={queryVariables}
          columns={columns}
          pageLength={25}
          buttons={buttons}
          lengthMenu={ [10, 25, 50, 'All'] }
          setSettings={setSettings}
          dataUpdated={data => setFilterOptions(data?.assetsWithCount)}
          htmlTable
        />
      </ContentContainer>
    </MainContainer>
  )
}

export default Assets;
